import React from 'react'
import { Button, Box, Typography } from '@mui/material'
import { Google as GoogleIcon } from '@mui/icons-material'

interface GoogleOAuthButtonProps {
  onClick: () => void
  disabled?: boolean
  text?: string
}

const GoogleOAuthButton: React.FC<GoogleOAuthButtonProps> = ({ 
  onClick, 
  disabled = false, 
  text = 'Continue with Google' 
}) => {
  return (
    <Button
      fullWidth
      variant="outlined"
      onClick={onClick}
      disabled={disabled}
      sx={{
        mt: 2,
        mb: 2,
        borderColor: '#dadce0',
        color: '#3c4043',
        textTransform: 'none',
        py: 1.5,
        '&:hover': {
          borderColor: '#c0c4c8',
          backgroundColor: '#f8f9fa'
        },
        '&.Mui-disabled': {
          borderColor: '#e0e0e0',
          color: '#9e9e9e'
        }
      }}
      startIcon={<GoogleIcon />}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="body1" sx={{ fontWeight: 500 }}>
          {text}
        </Typography>
      </Box>
    </Button>
  )
}

export default GoogleOAuthButton
